var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-checkbox',{staticClass:"rm-cb",attrs:{"value":_vm.item.selected,"color":"green"},on:{"click":_vm.clicked,"input":_vm.changed}})
}
var staticRenderFns = []

export { render, staticRenderFns }